import React, { useState, Children, Component } from 'react';
import { MailIcon, PhoneIcon, CheckCircleIcon, Loader2Icon } from 'lucide-react';
// ⬇️ ZAMENJAJTE z vašim Formspree ID-jem.
// 1. Pojdite na https://formspree.io in se prijavite z timotejsiter@gmail.com
// 2. Ustvarite nov obrazec ("New Form").
// 3. Kopirajte ID iz endpointa (npr. "xayzabcd" iz https://formspree.io/f/xayzabcd)
// 4. Prilepite ga spodaj namesto "your-form-id".
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mgobqrgb';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function RSVP() {
  const email = 'timotejsiter@gmail.com';
  const [name, setName] = useState('');
  const [adults, setAdults] = useState('');
  const [children, setChildren] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const subject = encodeURIComponent('Potrditev udeležbe - 70. rojstni dan');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: JSON.stringify({
          'Ime in priimek': name,
          Odrasli: adults,
          Otroci: children,
          _subject: 'Potrditev udeležbe - 70. rojstni dan Dani Siter'
        })
      });
      if (res.ok) {
        setStatus('success');
        setName('');
        setAdults('');
        setChildren('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  return <section id="potrditev" className="py-24 px-6 scroll-mt-24 bg-olive/[0.06]" data-id="element-125">
      <div className="max-w-4xl mx-auto text-center" data-id="element-126">
        <h2 className="text-4xl md:text-5xl mb-6" data-id="element-127">Prosimo za potrditev</h2>
        <div className="w-16 h-px bg-gold/50 mx-auto mb-10" data-id="element-128"></div>

        <p className="text-lg md:text-xl mb-12 font-light leading-relaxed" data-id="element-129">
          Prosimo, da do <span className="font-medium text-olive" data-id="element-130">25. 6.</span>{' '}
          sporočite, ali se boste praznovanja udeležili.
        </p>

        <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-131">
          {/* Form */}
          <div className="bg-white/50 p-8 rounded-sm border border-olive/10 shadow-sm flex flex-col" data-id="element-132">
            {status === 'success' ? <div className="flex flex-col items-center justify-center text-center h-full py-8" data-id="element-133">
                <CheckCircleIcon size={48} className="text-gold mb-4" strokeWidth={1.5} data-id="element-134" />
                <p className="font-serif text-2xl text-olive mb-2" data-id="element-135">Hvala!</p>
                <p className="font-sans text-soft-brown/90" data-id="element-136">
                  Vaša potrditev je bila uspešno poslana.
                </p>
              </div> : <form onSubmit={handleSubmit} className="flex flex-col h-full" data-id="element-137">
                <p className="font-serif text-xl italic text-olive mb-6 text-center" data-id="element-138">
                  Prijavnica
                </p>

                <label htmlFor="rsvp-name" className="font-sans text-sm font-medium text-soft-brown mb-2" data-id="element-139">
                  Ime in priimek
                </label>
                <input id="rsvp-name" type="text" required value={name} onChange={e => setName(e.target.value)} placeholder="npr. Janez Novak in Marija Novak" className="font-sans text-base px-4 py-3 mb-6 bg-ivory border border-olive/15 rounded-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition-colors" data-id="element-140" />

                <span className="font-sans text-sm font-medium text-soft-brown mb-2" data-id="element-141">
                  Koliko vas pride?
                </span>
                <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-142">
                  <div className="flex flex-col" data-id="element-143">
                    <label htmlFor="rsvp-adults" className="font-sans text-xs text-soft-brown/70 mb-1" data-id="element-144">
                      Odrasli
                    </label>
                    <input id="rsvp-adults" type="number" min={0} value={adults} onChange={e => setAdults(e.target.value)} placeholder="npr. 2" className="font-sans text-base px-4 py-3 bg-ivory border border-olive/15 rounded-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition-colors" data-id="element-145" />
                  </div>
                  <div className="flex flex-col" data-id="element-146">
                    <label htmlFor="rsvp-children" className="font-sans text-xs text-soft-brown/70 mb-1" data-id="element-147">
                      Otroci
                    </label>
                    <input id="rsvp-children" type="number" min={0} value={children} onChange={e => setChildren(e.target.value)} placeholder="npr. 1" className="font-sans text-base px-4 py-3 bg-ivory border border-olive/15 rounded-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition-colors" data-id="element-148" />
                  </div>
                </div>

                {status === 'error' && <p className="font-sans text-sm text-red-700/80 mb-4 text-center" data-id="element-149">
                    Prišlo je do napake. Poskusite znova ali nas pokličite.
                  </p>}

                <button type="submit" disabled={status === 'submitting'} className="mt-auto px-8 py-3 bg-olive text-ivory font-sans text-sm tracking-widest uppercase hover:bg-gold transition-colors duration-300 rounded-sm disabled:opacity-60 flex items-center justify-center gap-2" data-id="element-150">
                  {status === 'submitting' && <Loader2Icon size={16} className="animate-spin" data-id="element-151" />}
                  {status === 'submitting' ? 'Pošiljam...' : 'Potrdi udeležbo'}
                </button>
              </form>}
          </div>

          {/* Contact */}
          <div className="bg-white/50 p-8 rounded-sm border border-olive/10 shadow-sm flex flex-col justify-center" data-id="element-152">
            <p className="font-serif text-xl italic text-olive mb-6 text-center" data-id="element-153">
              Kontakt za prijavo
            </p>
            <div className="space-y-4 font-sans text-soft-brown" data-id="element-154">
              <a href={`mailto:${email}?subject=${subject}`} className="text-lg hover:text-gold transition-colors flex items-center justify-center gap-2" data-id="element-155">
                <MailIcon size={18} className="text-gold/70" data-id="element-156" />
                {email}
              </a>
              <a href="tel:+38640557673" className="text-lg hover:text-gold transition-colors flex items-center justify-center gap-2" data-id="element-157">
                <PhoneIcon size={18} className="text-gold/70" data-id="element-158" />
                +386 40 557 673 (Timotej)
              </a>
            </div>
            <p className="font-sans text-sm text-soft-brown/70 mt-8 italic text-center" data-id="element-159">
              Lahko nas pokličete ali pišete – kakor vam je lažje.
            </p>
          </div>
        </div>
      </div>
    </section>;
}